const getUtmFromUrl = () => {
    const queryParams = new URLSearchParams(window.location.search);
    return `|${queryParams.get('utm_source') ? queryParams.get('utm_source') : ''}|${
        queryParams.get('utm_medium') ? queryParams.get('utm_medium') : ''
    }|${queryParams.get('utm_campaign') ? queryParams.get('utm_campaign') : ''}`;
};

export const getUtmParams = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const utmSource = queryParams.get('utm_source') ? queryParams.get('utm_source') : '';
    const utmMedium = queryParams.get('utm_medium') ? queryParams.get('utm_medium') : '';
    const utmCampaign = queryParams.get('utm_campaign') ? queryParams.get('utm_campaign') : '';
    return `?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;
};

export default getUtmFromUrl;
